import { render, staticRenderFns } from "./TransactionListItem.vue?vue&type=template&id=4c745ad8&scoped=true&"
import script from "./TransactionListItem.vue?vue&type=script&lang=ts&"
export * from "./TransactionListItem.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionListItem.vue?vue&type=style&index=0&id=4c745ad8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c745ad8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VIcon,VRow})
